import axios from "axios";

// По умолчанию /api/* идут через CRA-proxy (см. package.json "proxy").
// Можно переопределить базовый URL через REACT_APP_API_BASE (напр. http://192.168.0.132:8700).
const client = axios.create({ baseURL: process.env.REACT_APP_API_BASE || "/" });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("Authorization");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (resp) => resp,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("Authorization");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default client;
